/*
 * Copyright (c) 2020. Dave van Rijn Development
 */

import './src/style/common-icons.scss';
import {library} from '@fortawesome/fontawesome-svg-core';
import {fab} from '@fortawesome/free-brands-svg-icons';
import {far} from '@fortawesome/free-regular-svg-icons';
import {fas} from '@fortawesome/free-solid-svg-icons';

library.add(fab, far, fas);


import ButtonController from "./src/js/button/buttonController";
import CheckboxController from "./src/js/checkbox/checkboxController";
import DialogController, {DialogActionShape} from "./src/js/dialog/dialogController";
import InlineDialog from "./src/js/dialog/inlineDialog";
import PasswordInput from "./src/js/input/password/passwordInput";
import PasswordRules from './src/js/input/password/passwordRules';
import LoaderController from "./src/js/loader/loaderController";
import SelectController from "./src/js/select/selectController";
import SnackbarController from "./src/js/snackbar/snackbarController";
import SwitchController from "./src/js/switch/switchController";
import ThemeContextProvider, {ThemeShape} from "./src/js/util/controlContext";
import NumberInput from "./src/js/input/number/numberInput";
import Label, {BreakType, LabelType} from './src/js/label/label';
import WithBackground from "./src/js/popup/withBackground";
import OptionsMenu from "./src/js/optionsMenu/optionsMenu";
import AwesomeIcon from "./src/js/icon/awesomeIcon";
import ColorPicker from './src/js/colorPicker/colorPicker';
import CloseButton from './src/js/button/closeButton';
import AnimatedTextField from './src/js/input/animated/animatedTextField';
import DVRHeader, {HeaderItem} from './src/js/header/DVRHeader';
import DateFieldController, {DateReturnType, DateType} from './src/js/input/date/dateFieldController';
import AsyncSelect from './src/js/select/async/asyncSelect';
import InputControllerV2 from './src/js/input/v2/inputController_v2';
import WithEvents from './src/js/events/withEvents';
import AppNavigator from "./src/js/navigator/navigator";
import DVRHead from './src/js/head/DVRHead';
import TopButton from './src/js/topButton/topButton';
import DVRCarouselController from './src/js/carousel/DVRCarouselController';
import DVRSlider from './src/js/slider/DVRSlider';
import PDFTemplateCreator from './src/js/pdf/pdfTemplateCreator';
import SidebarMenu from './src/js/sidebarMenu/sidebarMenu';
import Info from './src/js/info/info';
import Media from './src/js/media/media';
import DvrdButton, {DvrdButtonProps} from './src/js/button/dvrdButton';
import DvrdDatePicker, {DVRDDatePickerRef} from './src/js/date/dvrdDatePicker';
import DvrdInputController from './src/js/textField/dvrdInputController';
import DVRDNumberInput from './src/js/textField/dvrdNumberInput';
import DVRDPasswordInput from './src/js/textField/dvrdPasswordInput';
import Link from './src/js/link/link';
import DvrdOptionsList from './src/js/optionsList/dvrdOptionsList';
import DvrdSelectController from './src/js/select/dvrdSelectController';
import DVRDGroupedSelect, { GroupedSelectRef } from './src/js/select/dvrdGroupedSelect';
import DVRDSwitch from './src/js/switch/dvrdSwitch';
import DvrdHeaderController from './src/js/header/v2/dvrdHeaderController';
import FileUpload from './src/js/fileUpload/fileUpload';
import DvrdRadioController from './src/js/radio/dvrdRadioController';
import MobileNavigation from "./src/js/navigation/mobileNavigation";
import NumberString from './src/js/util/numberString';

export {
    // Components
    ButtonController as Button,
    CheckboxController as Checkbox,
    DialogController as Dialog,
    InlineDialog,
    PasswordInput as PasswordField,
    PasswordRules,
    NumberInput as NumberField,
    InputControllerV2 as TextField,
    AnimatedTextField,
    LoaderController as Loader,
    SelectController as Select,
    SnackbarController as Snackbar,
    SwitchController as Switch,
    ThemeContextProvider as ThemeProvider,
    WithBackground,
    Label,
    OptionsMenu,
    AwesomeIcon,
    ColorPicker,
    CloseButton,
    DVRHeader,
    DateFieldController as DateField,
    AsyncSelect,
    WithEvents,
    AppNavigator,
    DVRHead,
    TopButton,
    DVRCarouselController as DVRCarousel,
    DVRSlider,
    PDFTemplateCreator,
    SidebarMenu,
    Info,
    Media,
    DvrdButton,
    DvrdDatePicker,
    DVRDDatePickerRef,
    DvrdInputController as DvrdInput,
    DVRDNumberInput,
    DVRDPasswordInput,
    Link,
    DvrdOptionsList,
    DvrdSelectController as DvrdSelect,
    DVRDGroupedSelect,
    DVRDSwitch,
    DvrdHeaderController as DvrdHeader,
    FileUpload,
    DvrdRadioController as DvrdRadio,
    MobileNavigation,

    // Interfaces / Enums
    DialogActionShape,
    LabelType,
    BreakType,
    HeaderItem,
    DateReturnType,
    DateType,
    ThemeShape,
    DvrdButtonProps,
    GroupedSelectRef,
    NumberString,
};

export * from './src/js/util/controlUtil';
export * from './src/js/util/colorUtil';
export * from './src/js/util/miscUtil';
export * from './src/js/util/componentUtil';
export * from './src/js/util/eventUtil';
export * from './src/js/util/jwtUtil';
export * from './src/js/util/responsiveUtil';
export * from './src/js/util/validationUtil';
export * from './src/js/util/interfaces';
export * from './src/js/util/requestUtil';
export * from './src/js/util/constants';
export * from './src/js/util/cookieUtil';
export * from './src/js/util/pdfUtil';
export * from './src/js/util/googleUtil';
export * from './src/js/util/analyticsUtil';